  (() => {
    const root = document.querySelector('[data-fxgh]');
    if (!root) return;
    const KEY_NEXT = 'fxgh_next_at';
    const KEY_DONE = 'fxgh_done';
    const ls = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
    };
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    const credit = parseInt(root.dataset.credit, 10) || 3;
    const codes = [root.dataset.code1, root.dataset.code2, root.dataset.code3];
    const capDays = parseInt(root.dataset.cap, 10) || 30;

    const box = root.querySelector('.fxgh__box');
    const panel = root.querySelector('.fxgh__panel');
    const steps = [...root.querySelectorAll('.fxgh__step')];
    const meter = root.querySelector('[data-fxgh-meter]');
    const amountEl = root.querySelector('[data-fxgh-amount]');
    const fillEl = root.querySelector('[data-fxgh-fill]');
    const maxCredit = credit * 3;

    let open = false;
    let lockY = 0;
    let amount = 0;
    let correct = 0;
    let current = 'q1';
    let transitioning = false;
    const openedAt = { t: 0 };

    /* ---------- countdown: 24 h from the first correct answer, persisted per browser ---------- */
    const KEY_EXP = 'fxgh_expires_at';
    const timerHours = parseInt(root.dataset.timerHours, 10) || 0;
    const autoNextMs = (parseFloat(root.dataset.autoNext) || 0) * 1000;
    let autoNextId = null;
    const timerEls = [...root.querySelectorAll('[data-fxgh-timer-value]')];
    const timerWraps = [...root.querySelectorAll('[data-fxgh-tag]')]; /* countdown + bonus pills */
    let timerId = null;
    let timerShown = false;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const showTimer = (animate) => {
      if (timerShown || !timerWraps.length) return;
      timerShown = true;
      if (timerHours > 0 && timerEls.length) {
        tick();
        timerId = setInterval(tick, 1000);
      }
      timerWraps.forEach((w) => { w.hidden = false; });
      if (!animate || reduceMotion.matches) {
        timerWraps.forEach((w) => w.classList.add('is-in'));
        return;
      }
      requestAnimationFrame(() => requestAnimationFrame(() => timerWraps.forEach((w) => w.classList.add('is-in'))));
    };

    /* confetti: a dozen brand-colored particles burst from the number */
    const burstAnchor = root.querySelector('[data-fxgh-burst]');
    const burst = () => {
      if (!burstAnchor || reduceMotion.matches) return;
      const host = document.createElement('span');
      host.className = 'fxgh__burst';
      host.setAttribute('aria-hidden', 'true');
      burstAnchor.appendChild(host);
      const colors = ['#F9A63A', '#E08A1F', '#5D4037', '#190301', '#FAC078'];
      const count = 14;
      for (let i = 0; i < count; i++) {
        const p = document.createElement('span');
        p.className = 'fxgh__particle';
        p.style.background = colors[i % colors.length];
        if (i % 3 === 0) p.style.borderRadius = '50%';
        host.appendChild(p);
        const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.6;
        const dist = 44 + Math.random() * 46;
        const dx = Math.cos(angle) * dist;
        const dy = Math.sin(angle) * dist - 10;
        const rot = (Math.random() - 0.5) * 540;
        const dur = 700 + Math.random() * 300;
        p.animate(
          [
            { transform: 'translate(-3px, -3px) scale(0.4) rotate(0deg)', opacity: 1 },
            { transform: 'translate(' + (dx * 0.6 - 3) + 'px, ' + (dy * 0.6 - 3) + 'px) scale(1) rotate(' + rot * 0.6 + 'deg)', opacity: 1, offset: 0.55 },
            { transform: 'translate(' + (dx - 3) + 'px, ' + (dy + 22 - 3) + 'px) scale(0.7) rotate(' + rot + 'deg)', opacity: 0 }
          ],
          { duration: dur, easing: 'cubic-bezier(0.2, 0.8, 0.3, 1)', fill: 'forwards' }
        );
      }
      setTimeout(() => host.remove(), 1100);
    };
    const deadline = () => {
      let d = parseInt(ls.get(KEY_EXP) || '0', 10);
      if (!d) { d = Date.now() + timerHours * 36e5; ls.set(KEY_EXP, String(d)); }
      return d;
    };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      if (!timerEls.length) return;
      const left = Math.max(0, deadline() - Date.now());
      const h = Math.floor(left / 36e5), m = Math.floor(left % 36e5 / 6e4), sec = Math.floor(left % 6e4 / 1e3);
      const text = pad(h) + ':' + pad(m) + ':' + pad(sec);
      timerEls.forEach((el) => { el.textContent = text; });
      if (left <= 0) { clearInterval(timerId); timerId = null; }
    };

    /* ---------- open / close with the house body freeze ---------- */
    const openModal = () => {
      if (open) return;
      open = true;
      openedAt.t = Date.now();
      root.classList.toggle('is-done', current === 'done');
      /* the cover only downloads once the popup actually opens */
      const cover = root.querySelector('.fxgh__img');
      if (cover && !cover.getAttribute('src') && cover.dataset.src) cover.src = cover.dataset.src;
      root.hidden = false;
      box.scrollTop = 0;
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('fxgh--in')));
      lockY = window.scrollY;
      document.body.style.top = -lockY + 'px';
      document.documentElement.classList.add('fxgh-open');
      /* focus lands on the dialog itself (no visible ring), not on the first
         answer, so nothing looks pre-selected */
      panel.focus({ preventScroll: true });
    };
    const closeModal = (remember) => {
      if (!open) return;
      open = false;
      root.classList.remove('fxgh--in');
      document.documentElement.scrollTop = 0;
      document.documentElement.classList.remove('fxgh-open');
      document.body.style.top = '';
      window.scrollTo({ top: lockY, behavior: 'instant' });
      setTimeout(() => { root.hidden = true; }, 320);
      if (timerId) { clearInterval(timerId); timerId = null; }
      if (autoNextId) { clearTimeout(autoNextId); autoNextId = null; }
      if (remember && !designMode) ls.set(KEY_NEXT, String(Date.now() + capDays * 864e5));
    };
    /* iOS Safari: focusing a field inside a fixed body scrolls the document
       for the keyboard and can leave it at the very end when the keyboard
       goes. While the modal is open the only valid document position is 0,
       so pin it there on focus/blur and whenever the visual viewport
       changes size (keyboard in/out). */
    const pinTop = () => {
      if (!open) return;
      if (window.scrollY !== 0) window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    const emailField = root.querySelector('#fxgh-email');
    if (emailField) {
      emailField.addEventListener('focus', () => setTimeout(pinTop, 50));
      emailField.addEventListener('blur', () => setTimeout(pinTop, 50));
    }
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => setTimeout(pinTop, 50));
    root.querySelectorAll('[data-fxgh-close]').forEach((b) => b.addEventListener('click', () => closeModal(true)));
    root.addEventListener('click', (e) => { if (!panel.contains(e.target) && !e.target.closest('.fxgh__close')) closeModal(true); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && open) closeModal(true); });

    /* ---------- step machine ---------- */
    const show = (name) => {
      if (transitioning || name === current) return;
      transitioning = true;
      const from = steps.find((s) => s.dataset.step === current);
      const to = steps.find((s) => s.dataset.step === name);
      from.classList.add('is-leaving');
      from.classList.remove('is-active');
      root.classList.toggle('is-done', name === 'done');
      const foot = root.querySelector('[data-fxgh-foot]');
      if (foot) foot.hidden = !/^q\d$/.test(name);
      setTimeout(() => {
        from.classList.remove('is-leaving');
        to.classList.add('is-active');
        current = name;
        box.scrollTop = 0;
        transitioning = false;
        /* only a text field takes focus (typing); otherwise the dialog */
        const field = to.querySelector('input:not([type="hidden"])');
        if (field) field.focus({ preventScroll: true }); else panel.focus({ preventScroll: true });
      }, 240);
    };

    /* ---------- meter: count-up + honey fill ---------- */
    const setAmount = (target) => {
      const from = amount;
      amount = target;
      fillEl.style.setProperty('--p', String(target / maxCredit));
      const t0 = performance.now();
      const dur = 650;
      const tick = (now) => {
        const p = Math.min(1, (now - t0) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        amountEl.textContent = String(Math.round(from + (target - from) * eased));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    /* ---------- questions ---------- */
    steps.filter((s) => /^q\d$/.test(s.dataset.step)).forEach((step, idx) => {
      const group = step.querySelector('.fxgh__answers');
      const aha = step.querySelector('[data-fxgh-aha]');
      const nextWrap = step.querySelector('[data-fxgh-nextwrap]');
      const next = step.querySelector('[data-fxgh-next]');
      step.querySelectorAll('[data-fxgh-answer]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (group.classList.contains('is-locked')) return;
          group.classList.add('is-locked');
          const isRight = btn.dataset.correct === '1';
          /* first interaction on a phone: fold the image away */
          if (!root.classList.contains('is-collapsed')) {
            root.classList.add('is-collapsed');
            setTimeout(() => { box.scrollTo({ top: 0, behavior: 'smooth' }); }, 60);
          }
          if (isRight) {
            btn.classList.add('is-right');
            setTimeout(() => btn.classList.add('is-settled'), 1000);
            correct += 1;
            setAmount(amount + credit);
            burst();
          } else {
            btn.classList.add('is-wrong');
            const right = step.querySelector('[data-correct="1"]');
            if (right) {
              setTimeout(() => right.classList.add('is-right'), 220);
              setTimeout(() => right.classList.add('is-settled'), 1220);
            }
          }
          aha.innerHTML = '<strong>' + (isRight ? 'Richtig.' : 'Nicht ganz.') + '</strong> ' + step.dataset.aha;
          aha.hidden = false;
          nextWrap.hidden = false;
          requestAnimationFrame(() => requestAnimationFrame(() => {
            aha.classList.add('is-in');
            nextWrap.classList.add('is-in');
          }));
          /* auto-advance: bar runs once the button has faded in */
          if (autoNextMs > 0) {
            next.style.setProperty('--fxgh-auto', autoNextMs + 'ms');
            setTimeout(() => {
              if (!open) return;
              next.classList.add('is-filling');
              autoNextId = setTimeout(() => { autoNextId = null; if (open) next.click(); }, autoNextMs);
            }, 450);
          }
        });
      });
      next.addEventListener('click', () => {
        if (autoNextId) { clearTimeout(autoNextId); autoNextId = null; }
        next.classList.remove('is-filling');
        if (idx < 2) { show('q' + (idx + 2)); return; }
        /* after the third answer: score the round, prepare email + done */
        const tier = Math.max(1, correct);
        const total = tier * credit;
        const code = codes[tier - 1] || codes[0];
        root.querySelector('[data-fxgh-score]').textContent = correct + ' von 3 richtig';
        /* nobody leaves empty-handed: three wrong answers still get the
           smallest code, framed as a gift instead of a win */
        const gift = correct === 0;
        root.dataset.total = String(total); /* read by the Klaviyo call; the title text is not parseable in the gift case */
        root.querySelector('[data-fxgh-email-title]').textContent = gift ? 'Wir schenken Dir: ' + total + ' €.' : 'Dein Guthaben: ' + total + ' €.';
        root.querySelector('[data-fxgh-tags]').value = 'newsletter,guthaben-' + total;
        root.querySelector('[data-fxgh-done-title]').textContent = gift ? 'Wir schenken Dir: ' + total + ' €.' : total + ' € Gewinnguthaben gesichert.';
        root.querySelector('[data-fxgh-code]').textContent = code;
        const redeem = root.querySelector('[data-fxgh-redeem]');
        redeem.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.dataset.redirect || '/');
        if (correct === 0) setAmount(total);
        show('email');
        /* the 24 h clock starts once the credit is final */
        setTimeout(() => showTimer(true), 500);
      });
    });

    /* ---------- email: Klaviyo client subscribe (no CAPTCHA, double opt-in
       handled by the list); falls back to the Shopify customer form when
       no list id is configured ---------- */
    const form = root.querySelector('#fxgh-form');
    const submitBtn = root.querySelector('[data-fxgh-submit]');
    const errorEl = root.querySelector('[data-fxgh-error]');
    const klaviyoCompany = root.dataset.klaviyoCompany;
    const klaviyoList = root.dataset.klaviyoList;
    const subscribeKlaviyo = async (email) => {
      const total = parseInt(root.dataset.total, 10) || 0;
      const code = root.querySelector('[data-fxgh-code]').textContent;
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Guthaben-Popup',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { guthaben_betrag: total, guthaben_code: code, guthaben_quiz_richtig: correct }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: klaviyoList } } }
        }
      };
      const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(klaviyoCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('klaviyo ' + res.status);
    };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      /* spam tripwires: a filled honeypot or a submit within 6 s of opening
         is not a person; pretend success so scripts learn nothing */
      const emailInput = form.querySelector('#fxgh-email');
      if (emailInput && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailInput.value.trim())) {
        errorEl.hidden = false;
        emailInput.focus();
        return;
      }
      const hp = form.querySelector('[data-fxgh-hp]');
      if ((hp && hp.value) || (openedAt.t && Date.now() - openedAt.t < 6000)) {
        show('done');
        return;
      }
      submitBtn.disabled = true;
      try {
        if (klaviyoCompany && klaviyoList) {
          await subscribeKlaviyo(form.querySelector('#fxgh-email').value.trim());
        } else {
          const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' });
          if (!res.ok) throw new Error('status ' + res.status);
        }
        ls.set(KEY_DONE, root.querySelector('[data-fxgh-code]').textContent);
        ls.set(KEY_NEXT, String(Date.now() + 365 * 864e5));
        const field = form.querySelector('#fxgh-email');
        if (field) field.blur();
        pinTop();
        show('done');
      } catch (err) {
        errorEl.hidden = false;
      } finally {
        submitBtn.disabled = false;
      }
    });

    /* ---------- done: copy + redeem ---------- */
    root.querySelector('[data-fxgh-copy]').addEventListener('click', async (e) => {
      const b = e.currentTarget;
      const code = root.querySelector('[data-fxgh-code]').textContent;
      try { await navigator.clipboard.writeText(code); b.textContent = 'Kopiert'; } catch (err) { b.textContent = code; }
      setTimeout(() => { b.textContent = 'Kopieren'; }, 1800);
    });
    root.querySelector('[data-fxgh-redeem]').addEventListener('click', () => closeModal(true));

    /* ---------- triggers ---------- */
    const eligible = () => {
      if (designMode) return true;
      if (root.dataset.customer === '1') return false;
      if (ls.get(KEY_DONE)) return false;
      const next = parseInt(ls.get(KEY_NEXT) || '0', 10);
      if (next && Date.now() < next) return false;
      /* the window ran out without a signup: no restart of the clock,
         the popup waits out the cap instead */
      const exp = parseInt(ls.get(KEY_EXP) || '0', 10);
      if (timerHours > 0 && exp && Date.now() >= exp) {
        ls.set(KEY_NEXT, String(Date.now() + capDays * 864e5));
        try { localStorage.removeItem(KEY_EXP); } catch (e) { /* noop */ }
        return false;
      }
      return true;
    };
    const arm = () => {
      if (!eligible()) return;
      /* warm the cover now (page is loaded, LCP is done) so the panel
         never opens on a dark block */
      const cover = root.querySelector('.fxgh__img');
      if (cover) { cover.loading = 'eager'; cover.fetchPriority = 'low'; }
      const delay = Math.max(2, parseInt(root.dataset.delay, 10) || 8) * 1000;
      const scrollPct = parseInt(root.dataset.scroll, 10) || 50;
      const exit = root.dataset.exit === 'true';
      const readyAt = Date.now() + 2000;
      let fired = false;
      let interacted = false;
      let timerDone = false;
      let deferred = false;
      /* another house dialog is up (TUM study form, science modals, the
         PDP formula modal, the phone menu, the product assistant): the coupon waits and opens a
         moment after that one closes instead of stacking on top of it */
      const blocked = () => /\b(fxs-modal-open|fxpdm-modal-open|fx-menu-open|fx-chat-open)\b/.test(document.documentElement.className);
      const fire = () => {
        if (fired || Date.now() < readyAt) return;
        if (blocked()) { deferred = true; return; }
        fired = true;
        cleanup();
        openModal();
      };
      new MutationObserver(() => {
        if (deferred && !blocked()) { deferred = false; setTimeout(fire, 1200); }
      }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      /* Core Web Vitals guard: the popup must never become the page's LCP.
         Chrome stops LCP reporting at the first user interaction, so the
         delay only fires once the visitor has scrolled, tapped, typed or
         moved the pointer; a page nobody touches never opens it (and the
         Lighthouse trace, which never interacts, never sees it). */
      const markInteracted = () => {
        interacted = true;
        if (timerDone) fire();
      };
      const interactionEvents = ['scroll', 'pointerdown', 'pointermove', 'keydown', 'touchstart'];
      const onScroll = () => {
        markInteracted();
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max * 100 >= scrollPct) fire();
      };
      const onLeave = (e) => { if (!e.relatedTarget && e.clientY <= 8) fire(); };
      const timer = setTimeout(() => { timerDone = true; if (interacted) fire(); }, delay);
      const cleanup = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        interactionEvents.forEach((ev) => window.removeEventListener(ev, markInteracted));
        document.removeEventListener('mouseout', onLeave);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      interactionEvents.forEach((ev) => window.addEventListener(ev, markInteracted, { passive: true }));
      if (exit && window.matchMedia('(hover: hover) and (pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
    };

    /* Cookie banner first (WEB-24): on a first visit Shopify's privacy
       banner and this popup used to stack on top of each other. The
       triggers are only armed once a consent decision exists: a stored
       one, or a region without a regulation, arms right away; otherwise
       we wait for the banner's answer (accepting and declining both
       count) and the delay starts from there. shouldShowBanner() alone
       is not enough: it also says true in regions where Shopify never
       renders the banner (getRegulation() is empty there, e.g. CH), so
       the wait is limited to regulated regions, and a banner that has
       not appeared in the DOM after 10 s releases the popup too. If the
       privacy API cannot be loaded the popup arms as before. */
    const BANNER = '#shopify-pc__banner';
    const afterConsent = (fn) => {
      let done = false;
      const go = () => { if (done) return; done = true; fn(); };
      const check = (cp) => {
        if (!cp || typeof cp.shouldShowBanner !== 'function') { go(); return; }
        let pending = false;
        try {
          const regulated = typeof cp.getRegulation === 'function' ? !!cp.getRegulation() : true;
          pending = regulated && !!cp.shouldShowBanner();
        } catch (e) { go(); return; }
        if (!pending) { go(); return; }
        document.addEventListener('visitorConsentCollected', go, { once: true });
        setTimeout(() => { if (!document.querySelector(BANNER)) go(); }, 10000);
      };
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp) { check(cp); return; }
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') { go(); return; }
      /* a blocked or silent loader must not keep the popup shut for good */
      const loaderGuard = setTimeout(go, 5000);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
          clearTimeout(loaderGuard);
          check(window.Shopify.customerPrivacy || null);
        });
      } catch (e) { clearTimeout(loaderGuard); go(); }
    };
    const armAfterConsent = () => afterConsent(arm);

    if (designMode) {
      /* theme editor: open on section select, close on deselect */
      document.addEventListener('shopify:section:select', (e) => { if (e.target.contains(root)) openModal(); });
      document.addEventListener('shopify:section:deselect', (e) => { if (e.target.contains(root)) closeModal(false); });
    } else if (document.readyState === 'complete') {
      armAfterConsent();
    } else {
      window.addEventListener('load', armAfterConsent, { once: true });
    }
  })();
